export default "__VITE_ASSET__qExtn7x2__"